import { Star } from "lucide-react";

const STATS = [
  { value: "85,000+", label: "Installations across the U.S." },
  { value: "4.8★", label: "Google Business Profile · placeholder" },
  { value: "25 yr", label: "Production Guarantee" },
  { value: "10 yr", label: "Workmanship Warranty" },
];

const REVIEWS = [
  {
    name: "Marcus H. · Fredericksburg",
    quote: "Install was one day. The crew explained every step and the follow-up communication was unusually good.",
    rating: 5,
  },
  {
    name: "Priya S. · Loudoun County",
    quote: "We went with the PPA because we didn't want a big upfront check. Monthly bill is finally predictable.",
    rating: 5,
  },
  {
    name: "Dean R. · Henrico",
    quote: "HOA approval took a bit — the ION team handled the paperwork and kept me updated.",
    rating: 4,
  },
];

const SILFAB = [
  "North American solar manufacturing",
  "More than 35 years of solar innovation",
  "High-efficiency residential panels",
  "Backed by manufacturer warranty coverage",
];

export default function AboutION() {
  return (
    <section className="py-20 md:py-28 bg-[#FDFBF7]" data-testid="about-ion-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow">About ION</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C]">
            Finally, a solar company people actually like.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Long-term monitoring, customer-focused project communication, and premium equipment — with local Virginia teams.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {STATS.map((s) => (
            <div key={s.label} className="card-warm p-6">
              <div className="font-serif-display text-3xl text-[#0F382C]">{s.value}</div>
              <div className="text-xs mt-2 text-slate-500 leading-snug">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid lg:grid-cols-3 gap-6" data-testid="reviews-grid">
          {REVIEWS.map((r, i) => (
            <div key={i} className="card-warm p-6 flex flex-col">
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, idx) => (
                  <Star key={idx} className={`w-4 h-4 ${idx < r.rating ? "fill-[#D97706] text-[#D97706]" : "text-slate-300"}`} />
                ))}
              </div>
              <p className="font-serif-display text-lg text-[#0F382C] leading-snug flex-1">"{r.quote}"</p>
              <div className="mt-4 text-xs text-slate-500 font-mono-metric">{r.name}</div>
            </div>
          ))}
        </div>
        <p className="mt-6 text-xs text-slate-500">Verified review excerpts. Live Google Business Profile integration is admin-configurable — the above are labeled sample placeholders.</p>

        <div className="mt-20 rounded-3xl bg-[#0B261E] text-[#F8FAFC] p-8 md:p-12 grid lg:grid-cols-2 gap-10">
          <div>
            <div className="eyebrow" style={{ color: "#FEF3C7" }}>Panel Technology</div>
            <h3 className="mt-2 font-serif-display text-3xl md:text-4xl font-semibold">Our Silfab Panels</h3>
            <p className="mt-4 text-[#F8FAFC]/80 text-lg">Efficient, warranty-backed, and manufactured in North America.</p>
          </div>
          <ul className="space-y-3">
            {SILFAB.map((s) => (
              <li key={s} className="flex items-start gap-3 text-[#F8FAFC]/85">
                <div className="w-2 h-2 rounded-full bg-[#D97706] mt-2 shrink-0" />
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>
        <p className="mt-4 text-xs text-slate-500">Panel specifications, warranty PDFs, and certifications are added only from verified manufacturer materials.</p>
      </div>
    </section>
  );
}
